<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title>
          <span>{{ dialogData.title }}</span>
        </v-card-title>
        <v-card-text>
          <span>{{ dialogData.text }}</span>
          <span v-if="dialogData.value">
            <br v-if="dialogData.requireText" />
            <span v-else>? </span>
            <span class="error--text">{{ dialogData.value }}</span>
          </span>
          <div v-if="dialogData.details">
            <div v-for="item in dialogData.details" :key="item.id">
              <span>{{ item.text }}</span
              >{{ ' ' }} <span class="error--text">{{ item.value }}</span> คน
            </div>
          </div>
          <v-text-field
            v-if="dialogData.requireText"
            v-model="confirmationText"
            :placeholder="dialogData.requireText"
            :disabled="loading"
            class="mt-1"
            outlined
            dense
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="loading" text @click="$emit('cancelConfirmDialog')"
            >{{ dialogData.positiveBtn || 'ยกเลิก' }}
          </v-btn>
          <v-btn
            :loading="loading"
            :disabled="
              loading ||
              (dialogData.requireText &&
                confirmationText !== dialogData.requireText)
            "
            color="primary"
            text
            @click="$emit('submitConfirmDialog', dialogData.item)"
            >{{ dialogData.negativeBtn || 'ตกลง' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      confirmationText: '',
    }
  },
  watch: {
    dialog(value) {
      if (value) {
        this.confirmationText = ''
      }
    },
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      required: true,
    },
  },
}
</script>
